<div
  [ngClass]="
    confirmWalletMemo === '' || confirmWalletMemo === undefined
      ? 'modal'
      : confirmWalletMemo !== '' || confirmWalletMemo !== undefined
      ? 'refundStatusModal'
      : ''
  "
>
  <div class="mg-back-close-container end">
    <button
      *ngIf="confirmWalletMemo === '' || confirmWalletMemo === undefined"
      mat-icon-button
      [disableRipple]="true"
      (click)="closeCancelModal()"
      aria-label="back"
      color="primary"
    >
      <!-- <mat-icon>close</mat-icon> -->
      <img
        src="assets\images\icon-close.svg"
        alt="close-icon"
        class="close-icone"
      />
    </button>
  </div>
  <div class="modal-content">
    <ng-container
      *ngIf="
        confirmWalletMemo === '' || confirmWalletMemo === undefined;
        else confirmRefund
      "
    >
      <div class="trans-status">{{ cmsLabels.stellar.cancel.header }}</div>
      <div class="ref-number">
        {{ cmsLabels.stellar.transactionStatus.referenceNumber }}.
        {{ referenceNumber }}
      </div>
      <ng-container *ngIf="displaySelectReason; else refundDetailsTemplate">
        <div class="first hr"></div>
        <div class="app-summary-section-wrapper">
          <app-summary-section
            class="section-width"
            *ngFor="let section of reasonDetails?.sections"
            [displayTitle]="false"
            [items]="section.items"
            [title]="section.title"
          >
          </app-summary-section>
        </div>
        <div class="second hr"></div>
        <form novalidate class="cancel-form" *ngIf="form" [formGroup]="form">
          <mat-form-field
            class="custom-mat-form-field-select"
          >
            <mat-label>
              <span class="cancel-reason">{{
                cmsLabels.stellar.cancel.selectReason
              }}</span>
            </mat-label>
            <input
              type="text"
              formControlName="reason"
              matInput
              [matAutocomplete]="auto"
            />
            <mat-autocomplete
              #auto="matAutocomplete"
              [displayWith]="displayWithFn"
              (opened)="onAutoCompletePanelToggle(true)"
              (closed)="onAutoCompletePanelToggle(false)"
            >
              <ng-container *ngFor="let option of reasonOption | async">
                <mat-option
                  *ngIf="
                    getFilteredOptionRawValue(option?.description) !==
                    getReasonOptionRawValue(form.value)
                  "
                  [value]="option.description"
                  >{{ option.description }}</mat-option
                >
              </ng-container>
            </mat-autocomplete>
            <div class="icons-parent">
              <span mat-icon-button
                ><i class="material-icons">{{ arrowIcon }}</i></span
              >
            </div>
            <mat-error>
              <ng-container *ngIf="form!.get('reason')?.errors?.required">
                {{ cmsLabels.stellar.transactionStatus.reasonIsRequired }}
              </ng-container>
            </mat-error>
            <mat-error>
              <ng-container
                *ngIf="form!.get('reason')?.errors?.invalidOption"
                >{{ cmsLabels?.stellar?.cancel?.reasonNotFound }}</ng-container
              >
            </mat-error>
          </mat-form-field>

          <mat-form-field 
            *ngIf="isSubTaskReq"
            class="custom-mat-form-field-select"
          >
            <mat-label>
              <!-- <span class="cancel-reason">{{cmsLabels.stellar.cancel.selectReason}}</span> -->
              <span class="select-details">{{
                cmsLabels?.stellar?.cancel?.selectDetail
              }}</span>
            </mat-label>
            <input
              type="text"
              formControlName="subReason"
              matInput
              [matAutocomplete]="auto"
            />
            <mat-autocomplete
              #auto="matAutocomplete"
              [displayWith]="displayWithFn"
              (opened)="onAutoCompletePanelToggle(true)"
              (closed)="onAutoCompletePanelToggle(false)"
            >
              <ng-container *ngFor="let option of reasonSubOption | async">
                <mat-option
                  *ngIf="
                    getFilteredSubOptionRawValue(option?.description) !==
                    getReasonSubOptionRawValue(form.value)
                  "
                  [value]="option.description"
                  >{{ option.description }}</mat-option
                >
              </ng-container>
            </mat-autocomplete>
            <div class="icons-parent">
              <span mat-icon-button
                ><i class="material-icons">{{ arrowIcon }}</i></span
              >
            </div>
            <mat-error>
              <ng-container *ngIf="form!.get('subReason')?.errors?.required">
                {{ cmsLabels.stellar.transactionStatus.reasonIsRequired }}
              </ng-container>
            </mat-error>
            <mat-error>
              <ng-container
                *ngIf="form!.get('subReason')?.errors?.invalidOption"
                >{{ cmsLabels?.stellar?.cancel?.reasonNotFound }}</ng-container
              >
            </mat-error>
          </mat-form-field>

          <!-- <mat-form-field *ngIf="isTextBoxReq" class="reason-codes-text-area-field">
              <mat-label>
                <span class="text-area-label">{{TextBoxLabel}}</span></mat-label>
              <textarea formControlName="textArea" matInput class="codes-text-area"></textarea>
            </mat-form-field>
            <span class="text-area-down-label">
              <span *ngIf="isTextBoxReq" [ngClass]="{'normal-label': textBoxCharLen === 0, 'reamin-label': (textBoxCharLen !== 0 && remainCharLen >= 0), 'over-limit-label': remainCharLen < 0 }">{{textBoxCharLabels()}}</span>
            </span>  -->
          <div class="text-area-wrapper" *ngIf="isTextBoxReq">
            <div class="label-container">
              <span class="text-label"
                >{{ TextBoxLabel }} <sup class="asterik">*</sup></span
              >
            </div>
            <div
              class="text-area-container"
              [ngStyle]="{
                border: remainCharLen < 0 ? '1px solid #da291c' : ''
              }"
            >
              <div class="text-wrap">
                <textarea
                  formControlName="textArea"
                  class="codes-text-area"
                ></textarea>
              </div>
            </div>
            <span class="text-area-down-label">
              <span
                *ngIf="isTextBoxReq"
                [ngClass]="{
                  'normal-label': textBoxCharLen === 0,
                  'over-limit-label': remainCharLen < 0
                }"
                >{{ textBoxCharLabels() }}</span
              >
            </span>
          </div>

          <button
            type="button"
            class="w-full max-w-[327px]"
            [ngClass]="{
              'sign-in-disabled-btn-filled': form?.invalid,
              'sign-in-red-btn-filled': !form?.invalid
            }"
            [disabled]="form?.invalid"
            (click)="selectReason()"
          >
            {{ cmsLabels.stellar.cancel.cancelTransfer }}
          </button>
        </form>
      </ng-container>
      <ng-template #refundDetailsTemplate>
        <ng-container *ngIf="getRefundResponse?.refundTotalAmount?.value">
          <hr class="first-hr" />
          <div>
            <app-summary-section
              class="section-width"
              *ngFor="let section of refundDetails?.sections"
              [displayTitle]="false"
              [items]="section.items"
              [title]="section.title"
            >
            </app-summary-section>
          </div>
          <hr class="second-hr" />

          <div class="mg-step-actions-row">
            <button
              type="button"
              class="w-full max-w-[327px]"
              [ngClass]="{
                'sign-in-disabled-btn-filled': form?.invalid,
                'sign-in-red-btn-filled': !form?.invalid
              }"
              [disabled]="form?.invalid"
              (click)="onSubmit()"
            >
              {{ cmsLabels.stellar.confirm }}
            </button>
          </div>
        </ng-container>
      </ng-template>
    </ng-container>
    <ng-template #confirmRefund>
      <div class="no-cash-out-allowed">
        <div class="info-div">
          <img src="assets/images/green-tick.svg" alt="Success icon" />
        </div>
        <p class="refund-trans-status">
          {{ cmsLabels.stellar.cancel.cancelationSuccessful }}
        </p>
        <p class="refund-trans-status-message">
          {{ cmsLabels.stellar.cancel.cancelationSuccessfulHelpText }}
        </p>
      </div>
      <div class="mg-step-actions-row">
        <button
          type="button"
          class="w-full max-w-[327px] sign-in-red-btn-filled"
          (click)="closeModal()"
        >
          {{ cmsLabels.stellar.ok }}
        </button>
      </div>
    </ng-template>
  </div>
</div>
